<template>
  <layout class="booking-table">
    <page-header :header="$t('bookings.shared_transfer')" :actions="[]" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps">
        <template slot="booking.route" slot-scope="{ item: { booking } }">
          <booking-route :booking="booking" />
        </template>
        <template slot="vehicle" slot-scope="{ item: { vehicle, space_left } }">
          <div class="d-flex justify-content-start">
            <div>
              <div class="text-lg text-primary">{{ vehicle.name }}</div>
              <img
                v-if="vehicle.image"
                :src="vehicle.image"
                :alt="vehicle.name"
                class="max-w-full w-32"
              />
            </div>
            <div class="ml-5">
              <div class="text-lg font-weight-bold">
                {{ $t('general.vehicle_capacity') }}
              </div>
              <div>
                <i class="icon-user text-muted text-sm mr-1"></i>
                {{ space_left.seats }}
                <span class="text-muted">{{
                  $t('attributes.details.passengers.label')
                }}</span>
              </div>
              <div>
                <i class="icon-briefcase3 text-muted text-sm mr-1"></i>
                {{ space_left.luggage }}
                <span class="text-muted">{{ $t('vehicles.luggage') }}</span>
              </div>
              <div>
                <i class="icon-briefcase text-muted text-sm mr-1"></i>
                {{ space_left.small_luggage }}
                <span class="text-muted">{{
                  $t('vehicles.small_luggage')
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import SharingApi from './Api'
import BookingRoute from '../../../console/src/bookings/BookingRoute'

const resourceBase = 'bookings/sharing'

export default {
  name: 'SharingCompanions',

  components: {
    AdminTable,
    BookingRoute,
  },

  data() {
    return {
      actions: [],

      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new SharingApi()
        },
        searchFields: null,
        columns: [
          {
            key: 'booking.id',
            label: this.$t('general.id'),
          },
          {
            key: 'booking.route',
            label: this.$t('bookings.route'),
            tdClass: 'text-sm',
          },
          {
            key: 'booking.pickup_date',
            label: this.$t('bookings.pickup_date'),
            component: 'value-date',
            config: {
              stacked: true,
              zone: true,
              zoneAttribute: 'timezone',
            },
          },
          {
            key: 'vehicle',
            label: this.$t('bookings.vehicle_class'),
          },
        ],

        rowActions: item => {
          return [
            {
              label: this.$t('bookings.shared_join'),
              variant: 'success',
              handler: async () => {
                try {
                  await new SharingApi().join(
                    item.companion.id,
                    item.booking.id,
                  )
                  this.$refs.table.refresh()
                } catch (err) {
                  this.$toast.error(err.message)
                }
              },
            },
          ]
        },

        bulkActions() {
          return []
        },
      },

      currentTab: null,
    }
  },
}
</script>
